import React from 'react'
import styled from 'styled-components'

import DeathDrop, { Reset } from './DeathDrop'
import RadioGroup from './RadioGroup'
import defaultFilterOptions from '../data/filters.json'
import removeEmpty from './helpers/removeEmpty'

defaultFilterOptions['priorCollegeState'] = defaultFilterOptions.highSchoolState

function Sidebar({ filters, filterValues, handleInput }) {
  const filterOptions = React.useCallback(
    key =>
      filterValues
        ? defaultFilterOptions[key].filter(
            k => filterValues[key] && filterValues[key].indexOf(k.code) > -1
          )
        : defaultFilterOptions[key],
    [filterValues]
  )

  const rendered = React.useMemo(
    () => (
      <aside className="sidenav">
        <h2
          style={{
            paddingTop: '.75rem',
            paddingLeft: '.25rem',
            marginBottom: '0.5rem',
          }}
        >
          Filters
        </h2>
        <RadioGroup
          name="studentType"
          values={[
            { label: 'Freshmen', value: 'F' },
            { label: 'Transfer', value: 'T' },
          ]}
          onClick={handleInput}
          data={filters}
        />

        <Wrapper>
          <Fieldset>
            <legend>Residency</legend>
            {['All', 'In-State', 'Out-of-State'].map((item, i) => (
              <div key={i}>
                <input
                  type="radio"
                  id={item}
                  onChange={handleInput}
                  name="alabama"
                  checked={
                    !!(
                      (filters.alabama === 'true' && item === 'In-State') ||
                      (filters.alabama === 'false' &&
                        item === 'Out-of-State') ||
                      ((filters.alabama === undefined ||
                        filters.alabama === '') &&
                        item === 'All')
                    )
                  }
                  value={['', 'true', 'false'][i]}
                />
                <label htmlFor={item}>{item}</label>
              </div>
            ))}
          </Fieldset>
        </Wrapper>

        {/*
        sex: 'Sex',
  raceEthnicity: 'Race/Ethnicity',
  college: 'College',
  highSchoolState: 'High School State or Province',
  priorCollegeState: 'Prior College State or Province',
        */}

        <DeathDrop
          key="sex"
          name="sex"
          title="Sex"
          value={filters["sex"]}
          options={filterOptions("sex")}
          onChange={handleInput}
        />
        <DeathDrop
          key="raceEthnicity"
          name="raceEthnicity"
          title="Race/Ethnicity"
          value={filters["raceEthnicity"]}
          options={filterOptions("raceEthnicity")}
          onChange={handleInput}
        />
        <DeathDrop
          key="college"
          name="college"
          title="College"
          value={filters["college"]}
          options={filterOptions("college")}
          onChange={handleInput}
        />
        <Wrapper> 
          <input
            type="checkbox"
            name="distanceLearning"
            checked={!!filters['distanceLearning']}
            onChange={handleInput}
          />
          <label htmlFor="distanceLearning">Distance Learning</label>
        </Wrapper>

        {filters['studentType']==='F' &&
          <DeathDrop
            key="highSchoolState"
            name="highSchoolState"
            title="High School State"
            value={filters["highSchoolState"]}
            options={filterOptions("highSchoolState")}
            onChange={handleInput}
          />
        }
        
        {filters['studentType']==='T' &&
          <DeathDrop
            key="priorCollegeState"
            name="priorCollegeState"
            title="Prior College State"
            value={filters["priorCollegeState"]}
            options={filterOptions("highSchoolState")}
            onChange={handleInput}
          />
        }

        {filters.highSchoolState && (
          <DeathDrop
            name={'highSchoolCounty'}
            value={filters['highSchoolCounty']}
            options={defaultFilterOptions['highSchoolCounty'].filter(
              o => o.code.indexOf(filters.highSchoolState) === 0
            )}
            onChange={handleInput}
          />
        )}

        {filters.priorCollegeState && (
          <DeathDrop
            name={'priorCollegeCounty'}
            value={filters['priorCollegeCounty']}
            options={defaultFilterOptions['highSchoolCounty'].filter(
              o => o.code.indexOf(filters.priorCollegeState) === 0
            )}
            onChange={handleInput}
          />
        )}

        {Object.keys(removeEmpty(filters)).length > 0 && (
          <div style={{ padding: '0.5rem' }}>
            <Reset
              title="Reset All"
              name="reset-all"
              onClick={() => handleInput(true)}
            >
              ⎌ Reset All
            </Reset>
          </div>
        )}
      </aside>
    ),
    [filters, filterOptions, handleInput]
  )

  return rendered
}

export default Sidebar

const Wrapper = styled.div`
  margin: 0 5px;
`

const Fieldset = styled.fieldset`
  padding: 5px;
  color: black;
  margin-bottom: 5px !important;
`
